
import { useChartResources } from '@chart';

export default function (callback) {
    const TradingView = useChartResources('TradingView');
    setTimeout(() => callback(TradingView.config), 0);
}